import React, { useEffect, useState } from 'react';
import { translatePosition } from '../../services/talentTitleTranslation';
import { getCardPosition } from './talentResults';

export default function TalentPosition({ metadata = {}, language = 'en', showCompany = true, empty = '' }) {
  const { title, company, fallback } = getCardPosition(metadata);
  const arabic = language?.startsWith('ar');
  const [translated, setTranslated] = useState(null);
  useEffect(() => {
    let active = true;
    if (arabic && title) translatePosition(title).then(text => {
      if (active) setTranslated({ source: title, text });
    });
    return () => { active = false; };
  }, [arabic, title]);
  const label = arabic && translated?.source === title ? translated.text : title;
  if (!title) return <bdi dir="auto">{fallback || empty}</bdi>;
  return <span dir={arabic ? 'rtl' : 'ltr'}><bdi dir="auto" title={label !== title ? title : undefined}>{label}</bdi>
    {showCompany && company && <> {arabic ? 'لدى' : 'at'} <bdi dir="auto">{company}</bdi></>}
  </span>;
}
